export const mapUrlsToAttachmentField = (fileUrls: string[]) => {
  let fileObjs: any[] = [];
  const validFileUrls = (fileUrls ?? []).filter((fileUrl) => fileUrl?.trim());

  if (validFileUrls.length > 0) {
    fileObjs = validFileUrls.map((item: any) => {
      const nameParts = item.split('/');
      const nameParts2 = item.split('.');
      const name = nameParts[nameParts.length - 1];
      const tempObj = {
        id: name,
        name: name,
        status: 'done',
        dataUrl: item,
        url: item,
        image: item,
        size: 583954,
        // type:
        //   fileExtToTypeMap[nameParts2[nameParts2.length - 1]] ||
        //   nameParts2[nameParts2.length - 1],
        type: `image/${nameParts2[nameParts2.length - 1]}`,
      };
      return tempObj;
    });
  }

  return fileObjs;
};
